import { BrokerDto, CustomerDto } from '../shared';
import { IQuotationProductEntity } from '../entitites/quotation-product.entity';
import { PriceDto } from './common/price.dto';

export class QuotationProductDto {
  readonly guid: string;
  readonly title: string;
  readonly icon: string;
  readonly characteristic: string;
  readonly specs: Array<{
    label: string;
    value: string | null;
  }>;
  readonly price: PriceDto;

  constructor(entity: IQuotationProductEntity) {
    this.guid = entity.guid;
    this.title = entity.title;
    this.icon = entity.icon;
    this.characteristic = entity.characteristic;
    this.specs = entity.specs;
    this.price = new PriceDto(entity.price);
  }
}
